import { isSameDay, isSameHour, isSameMinute, isWithinInterval } from 'date-fns'
import { Availability, SelectedSlot } from '@customTypes/Availabilities'
import { ClinicAvailabilities } from 'src/services/api/availabilities'

export const getShouldResetSelectedBookable = (
  data?: ClinicAvailabilities[] | undefined,
  selectedBookableDateAndTime?: SelectedSlot,
  selectedDate?: Date,
  isFetching?: boolean
): boolean => {
  const { clinicId } = selectedBookableDateAndTime || {}
  if (!data?.length || !clinicId || !selectedDate || !selectedBookableDateAndTime || isFetching) {
    return false
  }

  const selectedSlotAvailableInData = data.some((clinicsAvailabilities) =>
    Object.values(clinicsAvailabilities).some((clinicAvailabilities) =>
      isWithinInterval(selectedDate, {
        start: clinicAvailabilities.fromDate,
        end: clinicAvailabilities.toDate,
      })
    )
  )

  if (!selectedSlotAvailableInData) {
    return true
  }

  const allClinicAvailabilities: Availability[] = []
  data.forEach((clinicsAvailabilities) => {
    const clinicAvailabilities = clinicsAvailabilities[clinicId || '']

    if (clinicAvailabilities) {
      clinicAvailabilities.weeks.forEach((week) => {
        week.forEach((date) => allClinicAvailabilities.push(...date.availabilities))
      })
    }
  })

  const isSameDate = (d1: Date, d2: Date) => isSameDay(d1, d2) && isSameHour(d1, d2) && isSameMinute(d1, d2)
  const isSlotAvailable = allClinicAvailabilities.some((availability) =>
    isSameDate(new Date(availability.originalStartTimestamp), selectedDate)
  )

  return !isSlotAvailable
}
